export { default as List } from 'projects/containers/ProjectsListContainer';
export { default as Form } from 'projects/containers/ProjectFormContainer';



// WEBPACK FOOTER //
// src/modules/secured/modules/projects/containers/index.js